// [2026-09-02] ADDED — the STAFF sign-in door for proctoring-sdk-backend.
//
// PASSWORD ONLY, AND NO SELF-REGISTRATION, NO PASSWORD RESET, NO GOOGLE. The highest-privilege
// account in the product deliberately has the FEWEST ways in: every extra door is another path to a
// credential that can read and write every tenant's data. Staff accounts are created by a superadmin
// from the Staff screen, or by scripts/seed_admin_user.py on a new deployment.
//
// THE BOOTSTRAP LOGIN IS NAMED HERE ON PURPOSE. `operator` + GATEWAY_OPERATOR_SECRET works with no
// database write at all, which is exactly what you need at 2am when the dashboard is the thing you
// are trying to fix. Documenting it in the UI is not a leak — the secret is the credential, and
// someone who holds it does not need a hint.
//
// IT IS NOT A SECURITY BOUNDARY. Anyone can open this page. The controls are server-side: the signed
// session, require_admin on every handler, and the role re-read from Mongo on each request.

import { useState } from 'react'
import { Notice } from '@incruiter/proctoring-client-frontend'
import { admin, setToken } from './api.js'

export default function AdminLogin({ onSignedIn }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [busy, setBusy] = useState(false)

  async function submit(event) {
    event.preventDefault()
    // Validated before spending a round trip — and, more to the point, before the server spends a
    // deliberately slow password hash on an obviously empty submission.
    if (!email.trim() || !password) {
      setError('Enter your email address and password.')
      return
    }
    setBusy(true)
    setError(null)
    try {
      const result = await admin.login(email.trim(), password)
      setToken(result.token)
      onSignedIn(result)
    } catch (err) {
      // The server answers identically for "no such account", "wrong password" and "disabled" — this
      // screen must not undo that by rendering three different messages.
      setError(err.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-card" style={{ maxWidth: 400 }}>
        <div className="brand" style={{ padding: '0 0 6px' }}>
          <span className="brand-mark">In</span><span>InC-Proctor — Staff</span>
        </div>
        <h1 style={{ fontSize: 22, margin: '10px 0 4px' }}>Staff sign-in</h1>
        <p className="muted" style={{ margin: '0 0 16px', fontSize: 13.5 }}>
          Platform administration, tenants and credits.
        </p>

        {error && <Notice kind="error">{error}</Notice>}

        <form onSubmit={submit}>
          <label className="field">
            <span>Email</span>
            <input type="text" value={email} required autoFocus autoComplete="username"
                   onChange={(e) => setEmail(e.target.value)} />
          </label>
          <label className="field">
            <span>Password</span>
            <input type="password" value={password} required autoComplete="current-password"
                   onChange={(e) => setPassword(e.target.value)} />
          </label>
          <button className="btn" type="submit" disabled={busy}
                  style={{ width: '100%', justifyContent: 'center' }}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="muted" style={{ margin: '14px 0 0', fontSize: 12 }}>
          No account yet on a fresh deployment? Sign in as <code>operator</code> with the
          deployment's operator secret, then create named accounts from the Staff screen.
        </p>
      </div>
    </div>
  )
}
